import { useQueryClient } from '@tanstack/react-query';
import { klwAxios, setKringloopwijzerId } from 'helpers/api';
import { atoms } from 'helpers/atoms';
import { useAtomValue } from 'jotai';

export const useLogout = () => {
  const keycloak = useAtomValue(atoms.auth.keycloakInstance);
  const queryClient = useQueryClient();

  return async () => {
    await queryClient.cancelQueries();
    setKringloopwijzerId(undefined);
    klwAxios.defaults.headers.common['Authorization'] = undefined;
    klwAxios.defaults.headers.common['Kvk-Proxy'] = undefined;
    localStorage.clear();
    localStorage.setItem('klw_was_active', '1');
    await keycloak.logout({ redirectUri: window.location.origin });
  };
};